<template>
  <q-separator :color="color" :class="cssClass"></q-separator>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    cssClass?: string
    color?: string
  }>(),
  {
    cssClass: 'q-my-lg',
  },
)
</script>
